import type {Node} from '../interfaces/node'
import type {Point} from '../interfaces/point'
import type {Range} from '../interfaces/range'
import {rangeEdges} from './range-edges'

export function rangeEnd(range: Range, root: {value: Array<Node>}): Point {
  const [, end] = rangeEdges(range, root)
  return end
}
